import { useState } from 'react';

import { useUserStrategies } from '../../context/UserStrategies';

import { AlignTable } from './AlignTable';
import { Wrapper } from './Wrapper';
import { CompareWidgetProps } from './types';

export const COLUMNS_ALIGN = [
  'ASSET',
  'TO DO',
  'QUANTITY',
  'TOTAL VALUE',
] as const;

export const AlignActive = ({ width }: CompareWidgetProps) => {
  const { strategies } = useUserStrategies();

  const [selectedStrategies, setSelectedStrategies] = useState(
    strategies.slice(0, 2).map(({ id }) => id)
  );

  const handleSelectedStrategies = (id: string, i: number) => {
    const newSelectedStrategies = i
      ? [selectedStrategies[0], id]
      : [id, selectedStrategies[1]];

    setSelectedStrategies(newSelectedStrategies);
  };

  return (
    <Wrapper title={'ALIGN STRATEGIES'} canShowChildren={strategies.length > 1}>
      <div className="flex h-auto divide-x divide-grey-10 dark:divide-grey-70">
        <AlignTable
          selectedStrategies={selectedStrategies}
          handleSelectedStrategies={handleSelectedStrategies}
        />
      </div>
    </Wrapper>
  );
};
